import { H2Flow, MaterialIcons, PrimaryButton } from '@monthio/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const DeletedMessageContainer = styled.div`
	padding: 16px;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	background: #ffeed9;
	border: 1px solid #ff6b00;
	box-shadow: 0px 0px 14px 0px rgba(53, 64, 82, 0.05);
`

const Message = styled.div`
	display: flex;
	align-items: center;

	> svg {
		margin-right: 8px;
		color: #ff6b00;
	}
`

interface ReactivateDebtMessageProps extends React.HTMLAttributes<HTMLDivElement> {
	reactivate: () => void
}

export const ReactivateDebtMessage: React.FC<ReactivateDebtMessageProps> = ({
	reactivate,
	...domAttributes
}) => {
	const { t } = useTranslation()
	return (
		<DeletedMessageContainer {...domAttributes}>
			<Message>
				<MaterialIcons.Warning />
				<H2Flow>{t('debtOverview-reactivateDebt-title')}</H2Flow>
			</Message>
			<PrimaryButton onClick={reactivate}>
				{t('debtOverview-reactivateDebt-reactivate')}
			</PrimaryButton>
		</DeletedMessageContainer>
	)
}
